import styled, { keyframes } from 'styled-components';
import { Icon } from '../icon';
import { getColorShade } from '../../../src/styled/utils';
const rotate = keyframes `
  100% {
    transform: rotate(360deg);
  }
`;
export const StyledSpinner = styled(Icon).attrs({
    name: 'spinner'
}) `
  color: ${({ color = 'onSurface', $colorShade = 'mediumEmphasis' }) => getColorShade(color, $colorShade)};
  transform: rotate(0deg);
  animation: ${rotate} 1.5s linear infinite;
  ${({ $isBig }) => $isBig && 'font-size: 48px'};
`;
